import React from "react";
import { RightChevronSvg } from "../icons/ChevronSvg";

export interface NavigationCardProps {
  data: {
    title: string
    tag: string
  }
  icon: any,
  href: string,
  eventLogger: (title:string) => void
}

const NavigationCard = (props: NavigationCardProps) => {
  const { data, icon, href, eventLogger } = props;

  const logEvent = (e) => {
    if (eventLogger) eventLogger(data.title);
  }
  return (
    <a href={href} target="_blank" onClick={logEvent}>
      <div
        className="shadow-lg dark:shadow-none rounded-xl dark:bg-theme-dark-light flex
        justify-between items-center p-4 cursor-pointer"
      >
        <div className="flex justify-center items-center">
          <div className="inline-block mr-4">{icon}</div>
          <div>
            <h3 className="font-bold">{data.title}</h3>
            <p className="text-sm text-gray-700 dark:text-gray-400">{data.tag}</p>
          </div>
        </div>

        <div>
          <RightChevronSvg className="w-10 h-10 stroke-current fill-current" />
        </div>
      </div>
    </a>
  );
}

export default NavigationCard;
